import React, { useState, useEffect } from "react";
import './MedicoView.css';

const ESTAGIOS = {
  1: { nome: "Recebida", cor: "#757575" },
  2: { nome: "Em análise", cor: "#1976d2" },
  3: { nome: "Analista", cor: "#0288d1" },
  4: { nome: "Médico", cor: "#8e24aa" },
  5: { nome: "Retornou Benef.", cor: "#fbc02d" },
  6: { nome: "Aprovada", cor: "#43a047" },
  7: { nome: "Recusada", cor: "#e53935" },
  8: { nome: "Concluída", cor: "#388e3c" }
};

// Modal de análise completa (detalhado)
function AnaliseModalCompleta({ id, onClose, onEncaminharMedico, onReload, viewMedico }) {
  const [detalhe, setDetalhe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showQuestionario, setShowQuestionario] = useState(false);
  const [showAnexos, setShowAnexos] = useState(false);
  const [anexosFamilia, setAnexosFamilia] = useState([]);
  const [reload, setReload] = useState(0);
  const [reloadInterno, setReloadInterno] = useState(0);
  const [statusQuestionario, setStatusQuestionario] = useState(null);
  const [obsQuestionario, setObsQuestionario] = useState([]);
  const [dependentes, setDependentes] = useState([]);
  const [showObsModal, setShowObsModal] = useState(false);
  const [showModalCritico, setShowModalCritico] = useState(false);
  const estagioAprovado = detalhe && detalhe.Estagio === 6 && dependentes.every(dep => dep.Estagio === 6);


function ModalCriticoMulti({ aberto, beneficiarios, onClose, onConfirm }) {
  const [criticos, setCriticos] = useState({});

  useEffect(() => {
    // inicializa tudo como false (não crítico)
    if (aberto) {
      const inicial = {};
      beneficiarios.forEach(b => {
        inicial[b.id] = false;
      });
      setCriticos(inicial);
    }
  }, [aberto, beneficiarios]);

  if (!aberto) return null;

  return (
    <div className="analise-modal-bg">
      <div className="analise-modal" style={{ minWidth: 400, maxWidth: 500 }}>
        <h3>Retornar para Analista</h3>
        <div style={{ margin: "14px 0" }}>
          <p style={{ marginBottom: 8, color: "#555" }}>
            Marque <b>Crítico</b> para cada beneficiário que exige atenção especial:
          </p>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {beneficiarios.map(b => (
              <li key={b.id} style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={!!criticos[b.id]}
                  onChange={e => setCriticos({ ...criticos, [b.id]: e.target.checked })}
                  id={`critico-${b.id}`}
                  style={{ marginRight: 8 }}
                />
                <label htmlFor={`critico-${b.id}`} style={{ fontWeight: 500 }}>
                  {b.nome} <span style={{ color: "#999", fontSize: 13 }}>({b.cpf})</span>
                  {!!criticos[b.id] && <span style={{ color: "#e53935", marginLeft: 10 }}>(Crítico)</span>}
                </label>
              </li>
            ))}
          </ul>
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button className="analise-btn" onClick={() => onConfirm(criticos)}>
            Confirmar
          </button>
          <button className="analise-btn-sec" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}


  // BOTOES DO ANALISE COMPLETA
async function encaminharParaAnalista() {
  const ids = [detalhe.id, ...dependentes.map(dep => dep.id)];
  const idMedico = localStorage.getItem("usuario_id") || "default-id";  // ID do médico do localStorage
  console.log("ID do médico:", idMedico); // Verifique no console se o ID está correto

  try {
    // Atualizar o Estágio para Analista (Estágio 3)
    const estagioResponse = await Promise.all(
      ids.map(bid =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            estagio: 3 // Encaminhado para analista
          })
        })
      )
    );

    if (estagioResponse.every(res => res.ok)) {
      // Se o estágio foi atualizado corretamente, atualizar o Médico
      const medicoResponse = await Promise.all(
        ids.map(bid =>
          fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/medico`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              medico: idMedico // Atualiza o ID do médico logado
            })
          })
        )
      );
      console.log("Respostas de atualização do médico:", medicoResponse); // Verifica as respostas no console

      if (medicoResponse.every(res => res.ok)) {
        alert("Todos foram encaminhados para o Analista e Médico!");
        if (onEncaminharMedico) onEncaminharMedico();
        if (onReload) onReload();
      } else {
        alert("Falha ao atualizar o Médico. Tente novamente.");
      }
    } else {
      alert("Falha ao atualizar o Estágio. Tente novamente.");
    }
  } catch (err) {
    alert("Falha ao encaminhar. Tente novamente.");
  }
}



  async function devolverParaBeneficiario() {
  const ids = [detalhe.id, ...dependentes.map(dep => dep.id)];
  try {
    await Promise.all(
      ids.map(bid =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 5 })
        })
      )
    );
    alert("Todos foram devolvidos ao Beneficiário!");
    if (onEncaminharMedico) onEncaminharMedico();
    if (onReload) onReload();
  } catch (err) {
    alert("Falha ao devolver. Tente novamente.");
  }
}

async function aprovarProposta() {
  const ids = [detalhe.id, ...dependentes.map(dep => dep.id)];
  try {
    await Promise.all(
      ids.map(bid =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 6 })
        })
      )
    );
    alert("Todos foram aprovados!");
    if (onEncaminharMedico) onEncaminharMedico();
    if (onReload) onReload();
  } catch (err) {
    alert("Falha ao aprovar. Tente novamente.");
  }
}

async function voltarParaAnalista() {
  const ids = [detalhe.id, ...dependentes.map(dep => dep.id)];
  try {
    await Promise.all(
      ids.map(bid =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 3 })
        })
      )
    );
    alert("Proposta(s) reaberta(s) para análise!");
    if (onEncaminharMedico) onEncaminharMedico();
    if (onReload) onReload();
  } catch (err) {
    alert("Falha ao reabrir. Tente novamente.");
  }
}

async function cancelarProposta() {
  const ids = [detalhe.id, ...dependentes.map(dep => dep.id)];
  try {
    await Promise.all(
      ids.map(bid =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${bid}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 7 })
        })
      )
    );
    alert("Proposta cancelada para todos!");
    if (onEncaminharMedico) onEncaminharMedico();
    if (onReload) onReload();
  } catch (err) {
    alert("Falha ao cancelar. Tente novamente.");
  }
}
// Função real do botão
async function voltarParaAnalistaMultiCritico(criticos) {
  const todos = [{ ...detalhe }, ...dependentes];
  const idMedico = localStorage.getItem("usuario_id"); // Defina o idMedico dentro da função
  console.log("ID do médico:", idMedico);  // Verifique no console para garantir

  try {
    // Atualiza estágio primeiro
    await Promise.all(
      todos.map(b =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${b.id}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 3 }) // Encaminhado para analista
        })
      )
    );

    // Depois, atualiza critico_medico de cada membro
    await Promise.all(
      todos.map(b =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${b.id}/critico`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ critico: criticos[b.id] ? 1 : 0 })
        })
      )
    );

    // Atualiza o médico
    await Promise.all(
      todos.map(b =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${b.id}/medico`, {
          method: "POST",  // Aqui o método é POST para o médico
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ medico: idMedico })  // Passa o ID do médico
        })
      )
    );

    alert("Devolvido ao analista!");
    setShowModalCritico(false);
    if (onEncaminharMedico) onEncaminharMedico();
    if (onReload) onReload();
  } catch (err) {
    alert("Falha ao devolver. Tente novamente.");
  }
}





useEffect(() => {
  if (!id) return;
 fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/observacoes`)
    .then(r => r.json())
    .then(setObsQuestionario)
    .catch(() => setObsQuestionario(null));
}, [id, reloadInterno]);



  useEffect(() => {
  setLoading(true);
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}`)
    .then(r => r.json())
    .then(data => {
      setDetalhe(data);
      setDependentes(data.dependentes || []); // <-- Aqui salva os dependentes no state
    })
    .finally(() => setLoading(false));
  }, [id, reloadInterno]);

  useEffect(() => {
    if (!id) return;
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/anexos`)
      .then(r => r.json())
      .then(setAnexosFamilia)
      .catch(() => setAnexosFamilia([]));
  }, [id, reload]);

  useEffect(() => {
  if (!id) return;
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/status_atual`)
    .then(r => r.json())
    .then(data => setStatusQuestionario(data))
    .catch(() => setStatusQuestionario(null));
}, [id, reloadInterno]);




  const formatData = d => {
    if (!d) return "";
    if (/^\d{8}$/.test(d)) return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
    const dt = new Date(d);
    return isNaN(dt.getTime()) ? "" : dt.toLocaleDateString();
  };
  const calcularIdade = (data) => {
    if (!data) return "";
    let dia, mes, ano;
    if (/^\d{8}$/.test(data)) {
      dia = parseInt(data.slice(0, 2), 10);
      mes = parseInt(data.slice(2, 4), 10) - 1;
      ano = parseInt(data.slice(4, 8), 10);
    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
      const parts = data.split("/");
      dia = parseInt(parts[0], 10);
      mes = parseInt(parts[1], 10) - 1;
      ano = parseInt(parts[2], 10);
    } else return "";
    const nascimento = new Date(ano, mes, dia);
    if (nascimento.getFullYear() !== ano || nascimento.getMonth() !== mes || nascimento.getDate() !== dia) return "";
    const hoje = new Date();
    let idade = hoje.getFullYear() - ano;
    if (hoje.getMonth() < mes || (hoje.getMonth() === mes && hoje.getDate() < dia)) idade--;
    return idade >= 0 ? idade : "";
  };

  if (loading) return <div className="analise-modal-bg"><div className="analise-modal"><div style={{ padding: 24, color: "#888" }}>Carregando detalhes...</div></div></div>;
  if (!detalhe) return <div className="analise-modal-bg"><div className="analise-modal"><div style={{ padding: 24, color: "#e04d4d" }}>Não encontrado.</div></div></div>;

  return (
    <div className="analise-modal-bg">
      <div className="analise-modal" style={{ maxWidth: 1500 }}>
        <h2 className="pv-section-title" style={{ marginTop: 0, marginBottom: 14 }}>Análise Completa</h2>
        <div style={{
          display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8, marginBottom: 14, alignItems: "center",
        }}>
          <div><b>Nome:</b> {detalhe.nome}</div>
          <div><b>CPF:</b> {detalhe.cpf}</div>
          <div><b>Data Nasc.:</b> {formatData(detalhe.data_nascimento)}
            {(() => {
              const idade = calcularIdade(detalhe.data_nascimento);
              return idade !== "" ? <span className="pv-tag">{idade} anos</span> : null;
            })()}
          </div>
          <div><b>Nome Mãe:</b> {detalhe.nome_mae}</div>
          <div><b>Email:</b> {detalhe.email}</div>
          <div><b>Celular:</b> {detalhe.celular}</div>
          <div><b>Telefone:</b> {detalhe.telefone}</div>
          <div><b>CEP:</b> {detalhe.cep}</div>
          <div style={{ gridColumn: "span 4" }}>
            <b>Endereço:</b> {detalhe.rua}, {detalhe.numero}, {detalhe.complemento}
          </div>
          <div><b>Bairro:</b> {detalhe.bairro}</div>
          <div><b>Cidade:</b> {detalhe.cidade}/{detalhe.estado}</div>
          <div><b>Vendedor:</b> {detalhe.vendedor}</div>
          <div><b>Corretora:</b> {detalhe.corretora}</div>
          <div><b>Analista:</b> {detalhe.analista_nome || detalhe.analista}</div>
          <div><b>Médico:</b> {detalhe.medico_nome || detalhe.medico}</div>
          <div><b>Estágio:</b> {detalhe.estagio_nome || detalhe.Estagio}</div>
          <div><b>Portabilidade:</b> {detalhe.Portabilidade}</div>
          <div><b>Plano:</b> {detalhe.nome_plano || detalhe.produto_id}</div>
          <div>
            <b>Sexo:</b>{" "}
            {["M", "m", "H", "h"].includes((detalhe.sexo || "").toUpperCase())
              ? "Homem"
              : ["F", "f", "Mulher"].includes((detalhe.sexo || "").toUpperCase())
                ? "Mulher"
                : detalhe.sexo_descricao || detalhe.sexo || "-"}
          </div>
          <div><b>Peso:</b> {detalhe.peso} kg</div>
          <div><b>Altura:</b> {detalhe.altura} cm</div>
          <div><b>IMC:</b>{" "}
            {detalhe.peso && detalhe.altura
              ? (detalhe.peso / Math.pow(detalhe.altura / 100, 2)).toFixed(2)
              : ""}
          </div>
        </div>
                {/* STATUS DO QUESTIONÁRIO - COLE ESTE BLOCO */}
        <div style={{ margin: "8px 0 16px 0", fontWeight: 500 }}>
          <span>Questionário: </span>
          {statusQuestionario?.status === "aprovado" && (
            <>
              <span style={{ color: "#43a047" }}>Aprovado</span>
              {statusQuestionario.usuario_nome && (
                <span> — Por <b>{statusQuestionario.usuario_nome}</b></span>
              )}
              {statusQuestionario.data_alteracao && (
                <span>
                  {" "}Em <b>{new Date(statusQuestionario.data_alteracao).toLocaleString()}</b>
                </span>
              )}
            </>
          )}
          {statusQuestionario?.status === "reprovado" && (
            <>
              <span style={{ color: "#e53935" }}>Reprovado</span>
              {statusQuestionario.usuario_nome && (
                <span> — Por <b>{statusQuestionario.usuario_nome}</b></span>
              )}
              {statusQuestionario.data_alteracao && (
                <span>
                  {" "}Em <b>{new Date(statusQuestionario.data_alteracao).toLocaleString()}</b>
                </span>
              )}
            </>
          )}
          {!statusQuestionario?.status && (
            <span style={{ color: "#888" }}>Em análise</span>
          )}
  {obsQuestionario && obsQuestionario.length > 0 && (
          <div style={{
              background: "#fffbe7",
              border: "1px solid #ffe082",
              borderRadius: 8,
              padding: "8px 14px",
              marginBottom: 12,
              marginTop: 4,
              fontSize: 15
          }}>
            <b>Histórico de Observações:</b>
            <ul style={{ margin: "8px 0 0 0", padding: 0, listStyle: "none" }}>
              {obsQuestionario.map((obs, idx) => (
                <li key={idx} style={{ marginBottom: 8 }}>
                  <span style={{ color: "#888" }}>
                    {obs.usuario_nome && <b>{obs.usuario_nome}</b>}
                   {obs.data_alteracao && (  <> — {obs.data_alteracao} </>)}

                  </span>
                  <span style={{ color: "#333", marginLeft: 10 }}>
                    — {obs.observacao}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}

        </div>                                        

        {/* FIM DO BLOCO STATUS DO QUESTIONÁRIO */}
        <div style={{ marginTop: 14, display: "flex", gap: 10 }}>
          {detalhe.questionario_id ? (
            <button className="analise-btn" onClick={() => setShowQuestionario(true)}>Ver Questionário Saúde</button>
          ) : (
            <span style={{ color: "#f9a825", fontWeight: 600, fontSize: 13, marginLeft: 8 }}>Sem questionário</span>
          )}
          {anexosFamilia.length > 0 && (
            <button className="analise-btn-sec" onClick={() => setShowAnexos(true)}>Anexos</button>
          )}
          <button
            className="analise-btn-sec"
            onClick={() => setShowObsModal(true)}
            style={{
                background: "#fffbe7",
                border: "1.5px solid #fbc02d",
                color: "#000000ff",
                fontWeight: 600
            }}
            >
            Observação
            </button>

        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 32 }}>
          <button className="analise-btn-sec" onClick={onClose}>Fechar</button>
        </div>
        {/* Bloco de Ações Destacado */}
        {(!detalhe.id_titular) && (
        <div
          style={{
            background: "#f5f5f5",
            borderRadius: 12,
            padding: "18px 20px",
            margin: "34px 0 10px 0",
            boxShadow: "0 1px 4px #0001",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
          }}
        >
          <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 12 }}>Ações disponíveis</div>
          <div style={{ display: "flex", gap: 12 }}>
           {viewMedico ? (
                <button className="analise-btn" onClick={() => setShowModalCritico(true)} disabled={estagioAprovado}>
                Encaminhar para Analista
                </button>

                ) : (
                <button className="analise-btn" onClick={encaminharParaAnalista} disabled={estagioAprovado}>
                    Encaminhar para Médico
                </button>
                )}

            

          </div>
        </div>
      )}
      <ModalCriticoMulti
        aberto={showModalCritico}
        beneficiarios={[{ ...detalhe }, ...dependentes]}
        onClose={() => setShowModalCritico(false)}
        onConfirm={voltarParaAnalistaMultiCritico}
        />


        {showQuestionario && (
            <ModalQuestionario
              id={id}
              onClose={() => {
                setShowQuestionario(false);
                setReloadInterno(x => x + 1); // << recarrega detalhes sem fechar Analise Completa
                if (onReload) onReload(); // opcional: recarrega lista pai também
              }}
              onEncaminharMedico={() => {
                if (onClose) onClose();
                if (onEncaminharMedico) onEncaminharMedico();
                if (onReload) onReload();  // <-- Adiciona aqui também, se quiser recarregar quando encaminha!
              }}
            />
          )}
          {showAnexos && (
            <ModalAnexos anexos={anexosFamilia} onClose={() => setShowAnexos(false)} />
          )}
          {showObsModal && (
            <ModalObservacao
                id={id}
                onClose={() => setShowObsModal(false)}
                onSalvou={(novaObs) => {
                setShowObsModal(false);
                setObsQuestionario(prev => [novaObs, ...prev]);
              }}

            />
            )}


      </div>
    </div>
  );
}
/// Modal Observacao
function ModalObservacao({ id, onClose, onSalvou }) {
  const [obs, setObs] = useState("");
  const [loading, setLoading] = useState(false);

  function handleSalvar() {
  if (!obs.trim()) {
    alert("Digite uma observação.");
    return;
  }
  setLoading(true);
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/questionario/status`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      status: "observacao",
      motivo: obs,
      usuario_nome: localStorage.getItem("nome_usuario") || "",
      usuario_cpf: localStorage.getItem("cpf_usuario") || ""
    })
  })
    .then(r => r.json())
    .then(() => {
        alert("Observação salva com sucesso!");

        const novaObs = {
          observacao: obs,
          usuario_nome: localStorage.getItem("nome_usuario") || "",
          data_alteracao: new Date().toISOString()
        };

        if (onSalvou) onSalvou(novaObs);
      })

    .catch(() => alert("Erro ao salvar observação."))
    .finally(() => setLoading(false));
}



  return (
    <div className="analise-modal-bg">
      <div className="analise-modal" style={{ minWidth: 340, maxWidth: 400 }}>
        <h3>Adicionar Observação</h3>
        <textarea
          value={obs}
          onChange={e => setObs(e.target.value)}
          placeholder="Digite sua observação..."
          style={{
            width: "100%",
            minHeight: 80,
            borderRadius: 8,
            border: "1px solid #bbb",
            marginBottom: 14,
            padding: 10
          }}
        />
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button className="analise-btn" onClick={handleSalvar} disabled={loading || !obs.trim()}>
            Salvar
          </button>
          <button className="analise-btn-sec" onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}


// Modal Questionário Saúde com edição in-line
function ModalQuestionario({ id, onClose, onEncaminharMedico }) {
  const [quest, setQuest] = useState([]);
  const [beneficiario, setBeneficiario] = useState(null);
  const nomeUsuario = localStorage.getItem("nome_usuario") || "";
  const cpfUsuario = localStorage.getItem("cpf_usuario") || "";
  const [editandoId, setEditandoId] = useState(null);
  const [respostaEditada, setRespostaEditada] = useState("");
  const [motivo, setMotivo] = useState("");
  const [showMotivoModal, setShowMotivoModal] = useState(false);
  const [acao, setAcao] = useState("");
  const [statusAtual, setStatusAtual] = useState(null);
  const [obsAtual, setObsAtual] = useState(null);
  const usuarioId = localStorage.getItem("usuario_id");
  const estagioAprovado = beneficiario && beneficiario.Estagio === 6;
  const [historicoObs, setHistoricoObs] = useState([]);

useEffect(() => {
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/observacoes`)
    .then(r => r.json())
    .then(setHistoricoObs)
    .catch(() => setHistoricoObs([]));
}, [id]);

  useEffect(() => {
  carregarStatusAtual();
  }, [id]);

  useEffect(() => {
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/questionario`)
      .then(r => r.json())
      .then(setQuest)
      .catch(() => setQuest([]));
  }, [id]);

  useEffect(() => {
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}`)
      .then(r => r.json())
      .then(setBeneficiario)
      .catch(() => setBeneficiario(null));
  }, [id]);

  useEffect(() => {
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/observacao_atual`)
    .then(r => r.json())
    .then(setObsAtual)
    .catch(() => setObsAtual(null));
  }, [id]);


  function handleEditar(q) {
    setEditandoId(q.pergunta_id);
    setRespostaEditada(q.resposta);
  }
  function handleCancelarEdicao() {
    setEditandoId(null);
    setRespostaEditada("");
  }

  function carregarStatusAtual() {
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/status_atual`)
    .then(r => r.json())
    .then(d => setStatusAtual(d)) // d é { status, usuario_nome, data_alteracao }
    .catch(() => setStatusAtual(null));
  }



  function handleSalvarResposta(perguntaId) {
    const motivoPrompt = prompt("Motivo da alteração desta resposta (para auditoria):");
    if (!motivoPrompt) return;
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/questionario`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        pergunta_id: perguntaId,
        resposta: respostaEditada,
        motivo: motivoPrompt,
        usuario_nome: nomeUsuario, // <- pego do localStorage no topo do componente!
        usuario_cpf: cpfUsuario
      })
    })
      .then(r => r.json())
      .then(() => {
        setQuest(qs =>
          qs.map(q =>
            q.pergunta_id === perguntaId
              ? { ...q, resposta: respostaEditada }
              : q
          )
        );
        setEditandoId(null);
        setRespostaEditada("");
        alert("Alteração salva com sucesso!");
      });
  }

  function handleMotivoConfirm() {
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/questionario/status`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        status: acao,
        motivo,
        usuario_nome: nomeUsuario,
        usuario_cpf: cpfUsuario,
        usuario_id: usuarioId
      })
    })
      .then(r => r.json())
      .then(() => {
        setShowMotivoModal(false);
        setMotivo("");
        setAcao("");
        alert("Status atualizado com sucesso!");
        carregarStatusAtual();
        if (acao === "Encaminhar_medico" && onEncaminharMedico) {
          onEncaminharMedico();
        }
      });
  }

  function handleMotivoCancel() {
    setShowMotivoModal(false);
    setMotivo("");
    setAcao("");
  }

  return (
    <div className="analise-modal-bg">
      <div className="analise-modal" style={{ maxWidth: 600 }}>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button className="analise-btn-sec" onClick={onClose}>
            Fechar
          </button>
        </div>
        <h3 style={{ marginTop: 8 }}>Questionário de Saúde</h3>
        <div style={{ marginBottom: 18, fontSize: 16 }}>
          <b>Nome:</b> {beneficiario?.nome || "-"}
          <br />
          <b>CPF:</b> {beneficiario?.cpf || "-"}
          <br />
          <b>Plano:</b> {beneficiario?.nome_plano || beneficiario?.produto_id || "-"}
        </div>
         <div style={{ marginBottom: 12 }}>
          <b>Situação: </b>
          {statusAtual?.status === "aprovado" ? (
            <>
              <span style={{ color: "#43a047", fontWeight: 600 }}>Aprovado</span>
              {statusAtual.usuario_nome && (
                <span style={{ marginLeft: 12 }}>
                  por <b>{statusAtual.usuario_nome}</b>
                </span>
              )}
              {statusAtual.data_alteracao && (
                <span style={{ marginLeft: 12 }}>
                  Data: <b>{new Date(statusAtual.data_alteracao).toLocaleString()}</b>
                </span>
              )}
            </>
          ) : statusAtual?.status === "reprovado" ? (
            <>
              <span style={{ color: "#e53935", fontWeight: 600 }}>Reprovado</span>
              {statusAtual.usuario_nome && (
                <span style={{ marginLeft: 12 }}>
                  por <b>{statusAtual.usuario_nome}</b>
                </span>
              )}
              {statusAtual.data_alteracao && (
                <span style={{ marginLeft: 12 }}>
                  Data: <b>{new Date(statusAtual.data_alteracao).toLocaleString()}</b>
                </span>
              )}
            </>
          ) : (
            <span style={{ color: "#888", fontWeight: 600 }}>Em análise</span>
          )}
        </div>
          {obsAtual && obsAtual.observacao && (
            <div style={{
              background: "#fffbe7",
              border: "1px solid #ffe082",
              borderRadius: 8,
              padding: "8px 14px",
              marginBottom: 12,
              marginTop: 4
            }}>
              <b>Observação:</b>{" "}
              {obsAtual && obsAtual.observacao ? (
                <>
                  <span style={{ color: "#888" }}>
                    {obsAtual.usuario_nome && <b>{obsAtual.usuario_nome}</b>}
                    {obsAtual.data_alteracao && (
                      <> — {new Date(obsAtual.data_alteracao).toLocaleString()} </>
                    )}
                  </span>
                  <span style={{ color: "#333", marginLeft: 10 }}>
                    — {obsAtual.observacao}
                  </span>
                </>
              ) : (
                <span style={{ color: "#aaa" }}>Sem observação</span>
              )}


            </div>
          )}

         




        {beneficiario?.obs_questionario && (
          <div style={{
            background: "#fffbe7",
            border: "1px solid #ffe082",
            borderRadius: 8,
            padding: "8px 14px",
            marginBottom: 16
          }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>Observação</div>
            <div style={{ color: "#555" }}>{beneficiario.obs_questionario}</div>
          </div>
        )}
        {quest.length === 0 ? (
          <div style={{ color: "#888", textAlign: "center" }}>
            Nenhuma resposta encontrada.
          </div>
        ) : (
          <table
            style={{
              width: "100%",
              background: "#f9fafd",
              borderRadius: 8,
              fontSize: 16,
            }}
          >
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "8px" }}>Pergunta</th>
                <th style={{ textAlign: "left", padding: "8px" }}>Resposta</th>
              </tr>
            </thead>
            <tbody>
              {quest.map(q => (
                <tr key={q.pergunta_id}>
                  <td style={{ padding: "8px 8px 8px 0" }}>{q.pergunta}</td>
                  <td style={{ padding: "8px", position: "relative" }}>
                    {q.resposta}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        

        {showMotivoModal && (
          <div className="analise-modal-bg">
            <div
              className="analise-modal"
              style={{
                minWidth: 350,
                maxWidth: 400,
                margin: "auto",
                padding: 24,
                textAlign: "center",
              }}
            >
              <div style={{ marginBottom: 12, fontWeight: 600 }}>
                {acao === "aprovar" && "Aprovação do Questionário"}
                {acao === "reprovar" && "Reprovação do Questionário"}
                {acao === "observacao" && "Adicionar Observação"}
                {acao === "encaminhar_medico" && "Encaminhar para Médico"}
              </div>
              <textarea
                style={{
                  width: "100%",
                  minHeight: 60,
                  borderRadius: 8,
                  border: "1px solid #bbb",
                  marginBottom: 16,
                  padding: 8,
                }}
                value={motivo}
                onChange={e => setMotivo(e.target.value)}
                placeholder="Descreva o motivo ou observação"
              />
              <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
                <button
                  className="analise-btn"
                  onClick={handleMotivoConfirm}
                  disabled={!motivo.trim()}
                >
                  Confirmar
                </button>
                <button className="analise-btn-sec" onClick={handleMotivoCancel}>
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


// Modal Anexos (igual PropostasView)
function ModalAnexos({ anexos = [], onClose }) {
  return (
    <div className="analise-modal-bg">
      <div className="analise-modal" style={{ minWidth: 400, maxWidth: 700 }}>
        <h3 className="pv-section-title" style={{ marginTop: 0 }}>Anexos</h3>
        {anexos.length === 0 ? (
          <div style={{ color: "#888", marginBottom: 12 }}>Nenhum anexo encontrado.</div>
        ) : (
          <ul style={{ margin: "4px 0 0 18px", padding: 0 }}>
            {anexos.map(ax => (
              <li key={ax.caminho} style={{ marginBottom: 2, listStyle: "disc" }}>
                <a
                  href={`https://gerencial.vionia.com.br/api/anexos/${ax.caminho}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {ax.nome}
                </a>
              </li>
            ))}
          </ul>
        )}
        <button className="analise-btn" onClick={onClose} style={{ marginTop: 16 }}>Fechar</button>
      </div>
    </div>
  );
}

export default function AnaliseView() {
  const [propostas, setPropostas] = useState([]);
  const [selecionada, setSelecionada] = useState(null);
  const [modalPacienteId, setModalPacienteId] = useState(null);
  const [reload, setReload] = useState(0);




  function getCodigoProposta(p, allPropostas) {
    if (!p) return "-";
    if (p.id_proposta) return p.id_proposta;
    if (p.tipo === "titular") {
      const dependente = allPropostas.find(
        x => x.tipo === "dependente" && x.id_titular === p.id && x.id_proposta
      );
      return dependente?.id_proposta || "-";
    }
    return "-";
  }

  useEffect(() => {
    const params = new URLSearchParams({
      page: 1,
      per_page: 10,
      estagio: 5
    });

    fetch(`https://gerencial.vionia.com.br/api/beneficiarios?${params}`)
      .then((res) => res.ok ? res.json() : [])
      .then((data) => {
        const agrupados = [];
        data.forEach(titular => {
            // Força critico_medico a existir sempre, pelo menos 0
            agrupados.push({ ...titular, tipo: "titular", critico_medico: titular.critico_medico ?? 0 });
            if (titular.dependentes && Array.isArray(titular.dependentes)) {
            titular.dependentes.forEach(dep => {
                agrupados.push({ ...dep, tipo: "dependente", id_titular: titular.id, critico_medico: dep.critico_medico ?? 0 });
            });
            }
        });
        setPropostas(agrupados);
         console.log("Titulares agrupados:", agrupados.filter(x => x.tipo === "titular"));
        })
      .catch(() => setPropostas([]));
  }, [reload]);

  function getDependentes(titularId) {
    return propostas.filter(p => p.tipo === "dependente" && p.id_titular === titularId);
  }

  function getTitularDependente(dep) {
    return propostas.find(p => p.tipo === "titular" && p.id === dep.id_titular);
  }

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>Análise Técnica</h2>
      {propostas.length === 0 ? (
        <p style={{ color: "#888" }}>Nenhuma proposta pendente.</p>
      ) : (
        <table className="analise-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Código Proposta</th>
              <th>Nome</th>
              <th>CPF</th>
              <th>Plano</th>
              <th>Data</th>
              <th>Corretora</th>
              <th>Vendedor</th>
              <th>Estágio</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {propostas.map((p) => (
                
              <React.Fragment key={`${p.tipo}-${p.id}`}>
                <tr 
                    className={
                        (p.critico_medico ? "analise-critico-medico " : "") +
                        (p.tipo === "dependente" ? "analise-dependente" : "")
                    }
                    >
                  <td>{p.id}</td>
                  <td>{getCodigoProposta(p, propostas)}</td>
                  <td>
                    {p.tipo === "dependente" ? (
                      <span style={{ marginLeft: 8 }}>↳ {p.nome} <small style={{ color: "#888" }}>(Dependente)</small></span>
                    ) : (
                      <strong>{p.nome}</strong>
                    )}
                  </td>
                  <td>{p.cpf}</td>
                  <td>{p.nome_plano || p.produto_id || "-"}</td>
                  <td>{p.data_inicio ? new Date(p.data_inicio).toLocaleDateString() : ""}</td>
                  <td>{p.corretora || "-"}</td>
                  <td>{p.vendedor || "-"}</td>
                  <td>
                    {ESTAGIOS[p.Estagio] ? (
                      <span
                        className="analise-badge-estagio"
                        style={{ background: ESTAGIOS[p.Estagio].cor }}
                      >
                        {ESTAGIOS[p.Estagio].nome}
                      </span>
                    ) : "-"}
                  </td>
                  <td>
                    <button
                      className="analise-btn"
                      onClick={() =>
                        setSelecionada(selecionada?.id === p.id && selecionada?.tipo === p.tipo ? null : p)
                      }
                    >
                      Ver Resumo
                    </button>
                  </td>
                </tr>
                {selecionada?.id === p.id && selecionada?.tipo === p.tipo && (
                  <tr>
                    <td colSpan={10}>
                      <div className="analise-resumo" style={{ marginTop: 0 }}>
                        <h3 style={{ marginTop: 0 }}>Resumo da Proposta #{p.id_proposta}</h3>
                        <div className="analise-grid">
                          <div><div className="analise-label">Nome</div>{p.nome}</div>
                          <div><div className="analise-label">CPF</div>{p.cpf}</div>
                          <div><div className="analise-label">Plano</div>{p.nome_plano || p.produto_id || "-"}</div>
                          <div><div className="analise-label">Data Início</div>{p.data_inicio ? new Date(p.data_inicio).toLocaleDateString() : ""}</div>
                          <div><div className="analise-label">Corretora</div>{p.corretora || "-"}</div>
                          <div><div className="analise-label">Vendedor</div>{p.vendedor || "-"}</div>
                          <div><div className="analise-label">Analista</div>{p.analista_nome || p.analista || "-"}</div>
                          <div><div className="analise-label">Médico</div>{p.medico_nome || p.medico || "-"}</div>
                          <div>
                            <div className="analise-label">Código Proposta</div>
                            {getCodigoProposta(p, propostas)}
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: 12, marginTop: 20 }}>
                          <button
                            className="analise-btn"
                            onClick={() => setModalPacienteId(p.id)}
                          >
                            Iniciar Análise
                          </button>
                          <button
                            className="analise-btn-sec"
                            onClick={() => setSelecionada(null)}
                          >
                            Fechar
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
              
            ))}
          </tbody>
        </table>
      )}
      
      {/* MODAL DE ANÁLISE COMPLETA */}
      {modalPacienteId && (
        <AnaliseModalCompleta
          id={modalPacienteId}
          onClose={() => {
            setModalPacienteId(null);
            setTimeout(() => setReload(x => x + 1), 300);
          }}
          onEncaminharMedico={() => {
            setModalPacienteId(null);
            setTimeout(() => setReload(x => x + 1), 300);
          }}
          onReload={() => setReload(x => x + 1)}
          viewMedico={true}
        />
      )}

    </div>
  );
}
